import { createWebBackApi } from '../../api/webBackApi';

const webBackApi = createWebBackApi({
  timeout: 180000,
});

export const uploadCustomerFile = async (customerId, file, folderPath = '') => {
  try {
    const formData = new FormData();
    formData.append('customerId', customerId);
    formData.append('file', file);
    formData.append('folderPath', folderPath);

    const response = await webBackApi.post(
      `/api/s3-customer-data/files/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error uploading file for customer ${customerId}:`, error);
    throw error;
  }
};

export const getCustomerStorage = async (customerId) => {
  try {
    const response = await webBackApi.get(
      `/api/s3-customer-data/files/storage/${customerId}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching storage for customer ${customerId}:`, error);
    throw error;
  }
};

export const deleteCustomerFile = async (fileId) => {
  try {
    const response = await webBackApi.delete(
      `/api/s3-customer-data/files/${fileId}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error deleting file ${fileId}:`, error);
    throw error;
  }
};

export const getCustomerFileDownloadUrl = async (fileId) => {
  try {
    const response = await webBackApi.get(
      `/api/s3-customer-data/files/${fileId}/download`
    );
    return response.data;
  } catch (error) {
    console.error(`Error getting download url for file ${fileId}:`, error);
    throw error;
  }
};

export const getCustomerFolders = async (customerId) => {
  try {
    const response = await webBackApi.get(
      `/api/s3-customer-data/folders/${customerId}`
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching folders for customer ${customerId}:`, error);
    throw error;
  }
};

export const createCustomerFolder = async (customerId, path) => {
  try {
    const response = await webBackApi.post(`/api/s3-customer-data/folders`, {
      customerId,
      path,
    });
    return response.data;
  } catch (error) {
    console.error(`Error creating folder ${path} for customer ${customerId}:`, error);
    throw error;
  }
};

export const renameCustomerFolder = async (customerId, path, newName) => {
  try {
    const response = await webBackApi.patch(
      `/api/s3-customer-data/folders/rename`,
      { customerId, path, newName }
    );
    return response.data;
  } catch (error) {
    console.error(`Error renaming folder ${path} for customer ${customerId}:`, error);
    throw error;
  }
};

export const deleteCustomerFolder = async (customerId, path) => {
  try {
    const response = await webBackApi.delete(`/api/s3-customer-data/folders`, {
      params: { customerId, path },
    });
    return response.data;
  } catch (error) {
    console.error(`Error deleting folder ${path} for customer ${customerId}:`, error);
    throw error;
  }
};

export const moveCustomerFile = async (fileId, folderPath) => {
  try {
    const response = await webBackApi.patch(
      `/api/s3-customer-data/files/${fileId}/move`,
      { folderPath }
    );
    return response.data;
  } catch (error) {
    console.error(`Error moving file ${fileId}:`, error);
    throw error;
  }
};
